import { Component } from '@angular/core';

import { SELECTED_USER_TYPE } from '../manage-access.constant';
import { ManageUserAccessFacade } from '../+state/manage-user-access.facade';
import { Router, ActivatedRoute } from '@angular/router';
import { User, EntitlementRole, EditedUser } from '../manage-access.model';

import { DialogExplainAccessComponent } from '@cigna/chcp/shared/ui';
import { DialogUserViewAccessComponent } from '../dialog-user-view-access/dialog-user-view-access.component';
import { DialogAssignmentRemoveUserComponent } from '../dialog-assignment-remove-user/dialog-assignment-remove-user.component';

import { MatDialog } from '@angular/material/dialog';
import { TinLob } from '@cigna/chcp/shared/util';
import { AuthFacade } from '@cigna/chcp/auth/data-access';
import { LOB_MEDBH } from '@cigna/chcp/auth/util';
import { FeatureTogglesFacade } from '@cigna/features';

@Component({
  selector: 'cigna-page-assign-access-bulk',
  templateUrl: './page-assign-access-bulk.component.html',
  styleUrls: ['./page-assign-access-bulk.component.scss'],
})
export class PageAssignAccessBulkComponent {
  userLob$ = this.authFacade.lob$;
  LOB_MEDBH = LOB_MEDBH;

  constructor(
    private manageAccessFacade: ManageUserAccessFacade,
    private featureTogglesFacade: FeatureTogglesFacade,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private authFacade: AuthFacade,
  ) {}

  USER_TYPE_EXISTING = SELECTED_USER_TYPE.exisiting;

  allTins$ = this.manageAccessFacade.allTins$;
  allEntitlements$ = this.manageAccessFacade.allEntitlements$;
  selectedUsers$ = this.manageAccessFacade.selectedUsers$;
  hiddenSteps$ = this.manageAccessFacade.hiddenSteps$;
  userType$ = this.manageAccessFacade.selectedUserType$;
  steps$ = this.manageAccessFacade.steps$;
  bulkEditSelectedEntitlements$ =
    this.manageAccessFacade.bulkEditSelectedEntitlements$;
  bulkEditSelectedEntitlementsValid$ =
    this.manageAccessFacade.bulkEditSelectedEntitlementsValid$;
  bulkEditSelectedTins$ = this.manageAccessFacade.bulkEditSelectedTins$;
  bulkEditSelectedTinsValid$ =
    this.manageAccessFacade.bulkEditSelectedTinsValid$;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  addUserValidationError = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  tinInputDirty = false;
  isPilotMHKUser$ = this.featureTogglesFacade.featuresEnabled(['pilotMHKUser']);

  removeUser(user: User): void {
    this.manageAccessFacade.unselectUserToEdit(user);
  }

  openExplainAccessDialog() {
    this.dialog.open(DialogExplainAccessComponent, {
      autoFocus: false,
      width: '700px',
    });
  }

  openUserAccessDialog(user: User) {
    this.dialog.open(DialogUserViewAccessComponent, {
      data: {
        user,
        showEdit: false,
      },
      autoFocus: false,
      width: '600px',
    });
  }

  openRemoveUserFromEditingDialog(user: User) {
    const dialogRef = this.dialog.open(DialogAssignmentRemoveUserComponent, {
      data: {
        user,
      },
      autoFocus: false,
      width: '400px',
    });

    dialogRef.componentInstance.removeUserFromEditing.subscribe(
      (selectedUser: EditedUser) => {
        dialogRef.close();
        this.removeUser(selectedUser);
      },
    );
  }

  tinSelectionsChange(tins: TinLob[]) {
    this.manageAccessFacade.updateEditedUsersBulkTins(tins);
    this.tinInputDirty = true;
  }

  entitlementsChange(entitlements: EntitlementRole[]) {
    this.manageAccessFacade.updateEditedUsersBulkEntitlements(entitlements);
  }

  previousScreen(): void {
    this.router.navigate(['../assignment-method'], {
      relativeTo: this.activatedRoute,
    });
  }

  nextScreen(): void {
    this.manageAccessFacade.bulkEditApplyChanges();
  }
}
